import { createFileRoute, redirect } from "@tanstack/react-router";

import { airHandlerUnitApi, alarmApi, boilerRoomApi, moduleApi } from "~/api";
import { AlarmsPage } from "~/features/alarms";
import { buildingHasSupervisableModules } from "~/features/alarms/helpers";
import { requirePagePermission } from "~/helpers/auth/route-permission.helper";
import { buildingPageHead } from "~/helpers/document-title.helper";
import { m } from "~/paraglide/messages";

export const Route = createFileRoute("/_authenticated/buildings_/$buildingId/alarms")({
  beforeLoad: ({ context: { permissions }, params: { buildingId }, preload }) => {
    requirePagePermission(permissions, "alarms", buildingId, preload);
  },
  loader: async ({ context: { queryClient }, params: { buildingId } }) => {
    // Sites with nothing to supervise (no GTB / boiler room / CTA) don't get the alarms page.
    const [modules, boilerRooms, airHandlerUnits] = await Promise.all([
      queryClient.ensureQueryData(moduleApi.queries.building(buildingId)),
      queryClient.ensureQueryData(boilerRoomApi.queries.building(buildingId)),
      queryClient.ensureQueryData(airHandlerUnitApi.queries.building(buildingId)),
    ]);
    if (!buildingHasSupervisableModules({ modules, boilerRooms, airHandlerUnits })) {
      throw redirect({ to: "/buildings/$buildingId/dashboard", params: { buildingId } });
    }
    await queryClient.ensureQueryData(alarmApi.queries.list(buildingId));
  },
  head: ({ match: { context }, params: { buildingId } }) =>
    buildingPageHead(context.queryClient, buildingId, m.alarms_title()),
  component: RouteComponent,
});

function RouteComponent() {
  return <AlarmsPage routeId={Route.id} />;
}
